import { NumberInput, NumberInputProps } from "../elements/NumberInput";
import { FormItemContainer, FormItemProps } from "./FormItemContainer";

type Props = NumberInputProps & FormItemProps<number>;

export const FormNumberInput = (props: Props) => {
  return (
    <FormItemContainer<number> {...props}>
      <NumberInput {...props} />
    </FormItemContainer>
  );
};
